import { StedIcon } from "@/assets/icons";
import { cn } from "@/lib/utils";

export type PlainLayoutProps = React.HTMLAttributes<HTMLDivElement> & {
  goBack?: boolean;
};

export const PlainLayout = ({ children, className }: PlainLayoutProps) => {
  return (
    <main className='space-y-16'>
      <header className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-24 flex gap-3 justify-center items-center'>
        {/* {goBack && (
          <GoBack asChild>
            <Button variant='mid' className='text-foreground'>
              <ChevronLeftIcon width={24} height={24} />
              Back
            </Button>
          </GoBack>
        )} */}
        <div className='flex-1 flex justify-center items-center'>
          <StedIcon size='md' />
        </div>
      </header>
      <section
        className={cn("max-w-3xl mx-auto px-4 sm:px-6 lg:px-8", className)}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        style={{ "--min-available-height": "10rem" } as any}
      >
        {children}
      </section>
    </main>
  );
};
